import {
  resolveTheme,
  useCatalogItems,
  useExerciseNameBySlug,
  useMaxEditorHost,
} from "@heraion/ui";

import { exerciseCatalog } from "../logger/exercisesCache";
import { confirmViaWindow } from "../confirm";
import { useThemePalette } from "../theme";
import { useProfileUnitOrNull } from "../ThemeProfileBridge";
import { writeMax } from "../writeMax";
import { useMaxesDataWeb } from "./useMaxesDataWeb";

// PG-11 — the web mirror of apps/mobile/src/maxes/useLoggerMaxEditor.tsx, and
// deliberately the same shape: the shared `useMaxEditorHost` does the work,
// this file only names the web seams (window confirm instead of RN Alert, no
// safe-area, the shell profile store instead of the profile context).
//
// ⚠️ It calls `useMaxesData` a THIRD time on this surface — MaxesScreen and
// the logger's own host deps each hold one already. That is the duplication
// web-rnw has lived with since the console was built (mobile avoids it with an
// app-wide Context) and this is not the slice that fixes it; the reads share a
// TTL and an in-flight promise, so the cost is state, not requests. Registered
// so it is a known copy rather than a discovered one.
export function useLoggerMaxEditor(): {
  onEditMax: (exerciseId: string) => void;
  sheet: React.ReactElement;
} {
  const { dark, family } = useThemePalette();
  const theme = resolveTheme(dark, family);
  const catalog = useCatalogItems({ catalog: exerciseCatalog });
  const { maxes, forceRefresh } = useMaxesDataWeb();
  const units = useProfileUnitOrNull();
  const exerciseName = useExerciseNameBySlug(catalog.raw);

  return useMaxEditorHost({
    writeMax,
    maxes,
    // null until the profile lands, so no sheet opens in a kg guess (MX-6).
    units,
    forceRefresh,
    confirm: confirmViaWindow,
    theme,
    exerciseName,
  });
}
